/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

export type V1QuizAdminQuestionsListStatus = typeof V1QuizAdminQuestionsListStatus[keyof typeof V1QuizAdminQuestionsListStatus];


export const V1QuizAdminQuestionsListStatus = {
  draft: 'draft',
  published: 'published',
  retired: 'retired',
} as const;
